import { useUserDataStorage } from "~/store/userdata";

export class Category {
  id: number = 0;
  name: string = "";
  slug: string = "";
  description: string = "";
  subCategories: Category[] = [];
  parentCategory: Category|undefined
  products:number[] = []
  constructor() {
    this.id = 0;
    this.name = "";
  }
  parseJson(retCat: { id: number; attributes: { [key: string]: any } }) {
    this.id = retCat.id;
    this.name = retCat.attributes.Name;
    this.slug = retCat.attributes.slug;
    this.description = retCat.attributes.Description ?? "";
    this.subCategories = [];
    if(retCat.attributes.products){
      if(!useUserDataStorage().loggedIn){
        retCat.attributes.products.data = retCat.attributes.products.data.filter((prod:any)=>prod.attributes.Public==true)
      }
      this.products = retCat.attributes.products.data.map((prod:any)=>prod.id)
    }
    if(retCat.attributes.parent && retCat.attributes.parent.data){
      const parentCategory = new Category()
      parentCategory.parseJson(retCat.attributes.parent.data)
      this.parentCategory = parentCategory
    }
    if (retCat.attributes.categories) {
      if (retCat.attributes.categories.data) {
        retCat.attributes.categories.data.forEach((value:any) => {
          const tempCat = new Category();
          tempCat.parseJson(value);
          this.subCategories.push(tempCat);
        });
      }
    }
  }

  toJSON () {
    const retValue = {...this}
    retValue.subCategories = this.subCategories.map((cat)=>cat.toJSON())
    retValue.parentCategory = this.parentCategory ? this.parentCategory.toJSON() : undefined
    return retValue
  }

  toApiJSON() {
    return {
      Name: this.name,
      Description: this.description,
      parent: this.parentCategory?.id ?? null,
    }
  }
}
